import { Button, Typography } from '@mui/material';
import { Box, Grid } from '@mui/material';
import { FormControlLabel, Switch } from '@mui/material';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import { undisplaySwipeableDrawerSummary } from '../../redux/SwipeableDrawer/actions/swipeableDrawerActions';
import { Link } from 'react-router-dom';
import { Chip } from '@mui/material';
import { commonGridSx, gridLocaleText, makeGridToolbar } from '../../utils/gridStyles';
import Add from '@mui/icons-material/Add';
import { AppButton } from '../UI';
import { DataGrid } from '../SortableDataGrid/SortableDataGrid';

const CustomToolbar = makeGridToolbar('Missions');

const statusConfig = {
  ACTIVE: { bg: '#f0fdf4', color: '#166534', border: '#86efac' },
  PASSIVE: { bg: '#fef3c7', color: '#92400e', border: '#fde68a' },
  TERMINÉE: { bg: '#fef2f2', color: '#dc2626', border: '#fecaca' },
};

function TabPanelMission({ count, missionsTermines, missionsContact, handlePageChange, setMissionsTermines, loading, id, history }) {
  const dispatch = useDispatch();

  const columns = [
    {
      field: 'numMission', headerName: 'N°', width: 80,
      renderCell: (p) => <Typography sx={{ fontSize: '1rem', color: '#475569' }}>{p.value || '—'}</Typography>,
    },
    {
      field: 'nom_mission', headerName: 'NOM MISSION', flex: 1, minWidth: 200,
      renderCell: (p) => (
        <Link to={`/societe/${p.row.consultant}/missions/${p.row.uuid}/view`}
          style={{ textDecoration: 'none', fontWeight: 600, color: '#03407b', fontSize: '1rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {p.value || '—'}
        </Link>
      ),
    },
    {
      field: 'statut', headerName: 'STATUT', width: 120,
      renderCell: (p) => {
        const cfg = statusConfig[p.value] || { bg: '#f8fafc', color: '#64748b', border: '#e2e8f0' };
        return (
          <Chip label={p.value || '—'} size="small"
            sx={{ background: cfg.bg, color: cfg.color, border: `1px solid ${cfg.border}`, fontWeight: 600, fontSize: '1rem', height: 22, borderRadius: '6px' }} />
        );
      },
    },
    {
      field: 'consultant', headerName: 'TALENT MANAGER', width: 160,
      renderCell: (p) => <Typography sx={{ fontSize: '1rem', color: '#475569' }}>{p.value ?? '—'}</Typography>,
    },
    {
      field: 'accountManager', headerName: 'DELIVERY MANAGER', width: 170,
      renderCell: (p) => <Typography sx={{ fontSize: '1rem', color: '#475569' }}>{p.value ?? '—'}</Typography>,
    },
    {
      field: 'createdAt', headerName: 'CRÉÉ LE', width: 120,
      renderCell: (p) => (
        <Typography sx={{ fontSize: '1rem', color: '#64748b' }}>
          {p.value?.date ? moment(p.value.date).format('DD/MM/YYYY') : '—'}
        </Typography>
      ),
    },
    {
      field: 'CV', headerName: 'CV EN COURS', width: 120, align: 'center', headerAlign: 'center',
      renderCell: (p) => (
        <Link
          to={{ pathname: `/candidats/missions/${p.row.uuid}/list`, state: { missionName: p.row.statut, societeName: p.row.nom_mission, missionNum: p.row.numMission, dateMission: p.row.accountManager } }}
          style={{ textDecoration: 'none', color: '#03407b', fontWeight: 600, fontSize: '1rem' }}
        >
          {p.value}
        </Link>
      ),
    },
  ];

  const rows = (missionsContact || []).map((m) => ({ ...m, id: m.uuid }));

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ width: '100%' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
          <AppButton
            variant="primary" size="small" startIcon={<Add fontSize="small" />}
            onClick={() => { dispatch(undisplaySwipeableDrawerSummary()); history.push(`/societe/${id}/missions/add`); }}
          >
            Ajouter une mission
          </AppButton>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Typography sx={{ fontSize: '1rem', fontWeight: 700, color: '#03407b', letterSpacing: '0.07em', textTransform: 'uppercase' }}>
              Missions terminées
            </Typography>
            <FormControlLabel
              control={
                <Switch checked={missionsTermines} onChange={(e) => setMissionsTermines(e.target.checked)} name="missionsTermines"
                  sx={{ '& .MuiSwitch-thumb': { backgroundColor: missionsTermines ? '#03407b' : '#9ca3af' }, '& .MuiSwitch-track': { backgroundColor: missionsTermines ? '#7fb3d3' : '#d1d5db', opacity: 1 } }}
                />
              }
              label="" sx={{ ml: 0, mr: 0 }}
            />
          </Box>
        </Box>
        <Box sx={{ borderRadius: 3, border: '1px solid #e2e8f0', height: '44vh', minHeight: 300, background: '#fff', overflow: 'hidden', display: 'flex', flexDirection: 'column', boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.04)' }}>
          <DataGrid
            rows={rows}
            columns={columns}
            getRowId={(row) => row.id}
            loading={loading}
            paginationMode="server"
            rowCount={count}
            paginationModel={{ page: 0, pageSize: 50 }}
            onPaginationModelChange={(m) => handlePageChange(m.page)}
            pageSizeOptions={[50]}
            disableRowSelectionOnClick
            showToolbar
            slots={{ toolbar: CustomToolbar }}
            slotProps={{ loadingOverlay: { variant: 'skeleton', noRowsVariant: 'skeleton' } }}
            localeText={gridLocaleText}
            sx={commonGridSx}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default withRouter(TabPanelMission);
